import React from 'react'
import SarasTrans from '../../notifications/SarasTrans';

const SarasFormMenuRow = (props) => {
    const { viewData } = props;

    return (
        <span className="ui-menu-item-wrapper" role="menuitem"><SarasTrans trKey={viewData.valF} value={viewData.valF} /></span>
    )
}

export default SarasFormMenuRow